<template>
  <div class="h-screen text-center">Mapa</div>
</template>
